import { getFullRootDomain } from '../links'
import { useSsrContext } from './useSsrContext'

export const useRootDomain = (): string => {
  const { processEnv } = useSsrContext()

  if (processEnv) {
    return getFullRootDomain(processEnv)
  }

  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin
  }
  return getFullRootDomain('')
}
